// Supabase user data (Auth, profiles, watchlist, ratings, progress). The code
// lives in ./data/*; this module re-exports it so existing imports keep working.
import * as account from './data/account';
import * as library from './data/library';
import * as shared from './data/shared';
import * as progress from './data/progress';

export const buildSupabaseUserProfile = account.buildSupabaseUserProfile;
export const fetchAccountProfiles = account.fetchAccountProfiles;
export const createAccountProfile = account.createAccountProfile;
export const updateAccountProfile = account.updateAccountProfile;
export const deleteAccountProfile = account.deleteAccountProfile;
export const ensureSupabaseProfile = account.ensureSupabaseProfile;
export const resolveSupabaseProfile = account.resolveSupabaseProfile;
export const getSupabaseSessionProfile = account.getSupabaseSessionProfile;
export const signInWithSupabase = account.signInWithSupabase;
export const signUpWithSupabase = account.signUpWithSupabase;
export const createSupabaseUserAsAdmin = account.createSupabaseUserAsAdmin;
export const signOutFromSupabase = account.signOutFromSupabase;
export const updateSupabaseProfile = account.updateSupabaseProfile;
export const uploadSupabaseAvatar = account.uploadSupabaseAvatar;
export const updateSupabasePassword = account.updateSupabasePassword;
export const fetchSupabaseProfiles = account.fetchSupabaseProfiles;
export const calculateTasteMatch = account.calculateTasteMatch;
export const averageRatingValue = library.averageRatingValue;
export const fetchSupabaseWatchlist = library.fetchSupabaseWatchlist;
export const addSupabaseWatchlistItem = library.addSupabaseWatchlistItem;
export const fetchSupabaseWatchlistStatusMap = library.fetchSupabaseWatchlistStatusMap;
export const updateSupabaseWatchlistStatus = library.updateSupabaseWatchlistStatus;
export const removeSupabaseWatchlistItem = library.removeSupabaseWatchlistItem;
export const fetchSupabaseRatings = library.fetchSupabaseRatings;
export const fetchSupabaseRatingMap = library.fetchSupabaseRatingMap;
export const saveSupabaseRating = library.saveSupabaseRating;
export const fetchSupabaseDashboardCounts = library.fetchSupabaseDashboardCounts;
export const enrichMediaRecords = shared.enrichMediaRecords;
export const fetchEpisodeProgress = progress.fetchEpisodeProgress;
export const fetchEpisodeProgressCounts = progress.fetchEpisodeProgressCounts;
export const markEpisodeWatched = progress.markEpisodeWatched;
export const unmarkEpisodeWatched = progress.unmarkEpisodeWatched;
export const updateWatchlistProgress = progress.updateWatchlistProgress;
export const fetchSupabaseContinueWatching = progress.fetchSupabaseContinueWatching;
export const upsertSupabaseContinueWatching = progress.upsertSupabaseContinueWatching;
export const fetchSupabaseResumePoint = progress.fetchSupabaseResumePoint;
export const removeSupabaseContinueWatching = progress.removeSupabaseContinueWatching;
export const fetchEpisodeHistory = progress.fetchEpisodeHistory;
export const removeTitleFromHistory = progress.removeTitleFromHistory;
export const fetchHiddenRecommendations = progress.fetchHiddenRecommendations;
export const setRecommendationHidden = progress.setRecommendationHidden;
